import React from 'react';
import BasicModal from './BasicModal';
import {
  DISCARD_DRAFT_CANCEL,
  DISCARD_DRAFT_CONFIRM,
  DISCARD_DRAFT_HEADER,
} from 'common/utils/offlineMode/constants';

type OfflineModeDraftModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  options: {
    organizationName?: string;
    onConfirm?: () => void;
  };
};

export default function OfflineModeDraftModal({
  isOpen,
  closeModal,
  options,
}: OfflineModeDraftModalProps) {
  const { organizationName = 'this organization', onConfirm } = options;

  return (
    <BasicModal
      ariaLabelBody="Unsent message will be discarded"
      ariaLabelCancelButton="Keep the draft and stay here"
      ariaLabelCloseButton="Close this dialog"
      ariaLabelHeader={DISCARD_DRAFT_HEADER}
      ariaLabelSubmitButton="Discard the draft and switch to Offline Mode"
      cancelText={DISCARD_DRAFT_CANCEL}
      headerText={DISCARD_DRAFT_HEADER}
      isOpen={isOpen}
      onClose={closeModal}
      onSubmit={() => {
        onConfirm?.();
        closeModal();
      }}
      submitText={DISCARD_DRAFT_CONFIRM}
    >
      <p>
        {`Switching to ${organizationName}'s local server reloads this tab, and the message you have not sent yet will be discarded.`}
      </p>
    </BasicModal>
  );
}
